import Head from 'next/head';
import { useRouter } from 'next/router';
import config from '@/config/general';
import envConfig from '@/config/environment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TWITTER_DEFAULT_IMG = `${envConfig.baseUrl}/img/social/twitter-post.jpg`;
const OG_DEFAULT_IMG = envConfig.defaultSocialImg;

const SEO = _ref => {
  let {
    title,
    description,
    noIndex,
    twitterImgSrc,
    twitterImgAlt,
    ogImageSrc
  } = _ref;
  const ogImage = ogImageSrc || OG_DEFAULT_IMG;
  const router = useRouter();
  const pageUrl = [envConfig.baseUrl, router.pathname].filter(path => Boolean(path) && path !== '/').map(path => path.replace(/^\//g, '')).join('/');
  return /*#__PURE__*/_jsxs(Head, {
    children: [/*#__PURE__*/_jsx("title", {
      children: title || config.productName
    }), /*#__PURE__*/_jsx("meta", {
      content: "en_US",
      property: "og:locale"
    }), /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: description || config.description
    }), /*#__PURE__*/_jsx("link", {
      rel: "canonical",
      href: `${pageUrl}`
    }), /*#__PURE__*/_jsx("meta", {
      content: ogImage,
      property: "og:image"
    }), /*#__PURE__*/_jsx("meta", {
      content: "1200",
      property: "og:image:width"
    }), /*#__PURE__*/_jsx("meta", {
      content: "628",
      property: "og:image:height"
    }), /*#__PURE__*/_jsx("meta", {
      content: `image/${getImageType(ogImage)}`,
      property: "og:image:type"
    }), /*#__PURE__*/_jsx("meta", {
      content: pageUrl,
      property: "og:url"
    }), /*#__PURE__*/_jsx("meta", {
      content: "website",
      property: "og:type"
    }), /*#__PURE__*/_jsx("meta", {
      content: title || config.productName,
      property: "og:title"
    }), /*#__PURE__*/_jsx("meta", {
      content: config.productName,
      property: "og:site_name"
    }), /*#__PURE__*/_jsx("meta", {
      content: description || config.description,
      property: "og:description"
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:title",
      content: title || config.productName
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:description",
      content: description || config.description
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:image",
      content: twitterImgSrc || TWITTER_DEFAULT_IMG
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:card",
      content: "summary_large_image"
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:image:alt",
      content: twitterImgAlt || config.description
    }), noIndex && /*#__PURE__*/_jsx("meta", {
      name: "robots",
      content: "noindex"
    })]
  });
};

export default SEO;

function getImageType(img) {
  const fileType = (`${img || ''}`.split('.').pop() || '').toLowerCase();

  if (fileType === 'jpg') {
    return 'jpeg';
  }

  return fileType;
}